import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'BombSwap',
  description: 'The Fantom Opera exclusive exchange.',
  image: 'https://fbomb.finance/banner.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('BombSwap')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('BombSwap')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('BombSwap')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('BombSwap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('BombSwap')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('BombSwap')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('BombSwap')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('BombSwap')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('BombSwap')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('BombSwap')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('BombSwap')}`,
      }
    default:
      return null
  }
}
